<template>
  <NuxtLink :href="url"
            target="_blank"
            rel="noreferrer"
  >
    <img :src="imgSrc"
         :alt="imgAlt"
         class="object-contain w-full h-full"
    >
  </NuxtLink>
</template>

<script setup lang="ts">
import { StoreId } from '~/constants'

type ButtonStore = {
  storeId: StoreId
  url: string
}

const props = defineProps<ButtonStore>()

let imgSrc = ''
let imgAlt = ''

if (props.storeId === StoreId.APPLE_ARCADE) {
  imgSrc = 'https://cdn.outfit7.com/web/stores/apple-arcade/button.png'
  imgAlt = 'Find it on Apple Arcade'
}
else if (props.storeId === StoreId.APP_STORE) {
  imgSrc = 'https://cdn.outfit7.com/web/stores/app-store/button.png'
  imgAlt = 'Downlod on the App Store'
}
else if (props.storeId === StoreId.GOOGLE_PLAY) {
  imgSrc = 'https://cdn.outfit7.com/web/stores/google-play/button.png'
  imgAlt = 'Get it on Google Play'
}
else if (props.storeId === StoreId.AMAZON_APPSTORE) {
  imgSrc = 'https://cdn.outfit7.com/web/stores/amazon-appstore/button.png'
  imgAlt = 'Available at Amazon Appstore'
}
else if (props.storeId === StoreId.HUAWEI_APPGALLERY) {
  imgSrc = 'https://cdn.outfit7.com/web/stores/huawei-appgallery/button.png'
  imgAlt = 'Explore it on AppGallery'
}
else {
  throw new Error('Invalid or missing store ID')
}
</script>
